const USER_CANCELLED_CODES = ['VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED', 'VENMO_DESKTOP_CANCELED'];

export const isUserCancelledError = (error: unknown): boolean => {
	if (typeof error === 'object' && error !== null && 'code' in error && typeof error.code === 'string') {
		const { code } = error;
		return USER_CANCELLED_CODES.includes(code);
	}
	return false;
};
